import { css } from "lit";

export const styles = css`
  :host {
    display: contents;
  }

  a {
    flex: 1;
    color: inherit;
    text-decoration: inherit;
    display: inherit;
    align-items: inherit;
    justify-content: inherit;
    flex-direction: inherit;
    gap: inherit;
    border-radius: inherit;
    background: inherit;
    border: inherit;
    cursor: pointer;
  }

  a:hover {
    color: inherit;
    text-decoration: inherit;
  }

  a:focus {
    outline: inherit;
  }
`;
